<template>
	<div class="">
		<h2>Достижения</h2>
		<back></back>
		<div class="game scores">

      <ul class="uk-grid-match uk-grid-divider" uk-grid>
          <li class="uk-width-1-3@s">
              <div>
                <Avatars />
                <StatusTable />
              </div>
          </li>
          <li class="uk-width-2-3@s">
              <div>
                <h2>У тебя
                  <strong>{{ user.scores ? user.scores : 0 }}</strong> {{ $root.getNoun((user.scores ? user.scores : 0), 'балл', 'балла', 'баллов') }}
                </h2>
                <div class="rating__ava" v-if="user.avatar">
                  <img :src="user.avatar.image.path" alt="">
                </div>
                <div class="rating" v-if="hasStatus">
                  <div class="rating__title">
                    <small>Твой статус:</small>
                    {{ user.status.title }}
                  </div>
                  <div class="rating__to">
                    Чтобы перейти на следующий уровень,<br>тебе осталось набрать <span>{{ user.status.scores_to - user.scores }}</span> баллов!
                  </div>
                  <div class="rating__subtitle">Рейтинг в твоём уровне:</div>
                  <RatingTable />
                </div>
              </div>
          </li>
      </ul>
		</div>
	</div>
</template>

<script>
  import RatingTable from "./RatingTable";
  import Avatars from './Avatars'
  import StatusTable from "./StatusTable";
  import { mapGetters } from 'vuex'
  export default {
    name: "scores",
	  components: {
      RatingTable, Avatars, StatusTable
	  },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      hasStatus(){
        return !_.isEmpty(this.user.status);
      }
    }
  }
</script>